// Site core's own page and chrome strings (#1118): the built-in nav links
// and tab titles, page view-model defaults (home section titles, buyer
// fields, filters) and the league-not-found screen. Every template reads
// them through core, never directly.

const en = {
  /** The league's name until the tenant loads. */
  leagueFallback: 'League',
  leagueNotFound: {
    title: 'League Not Found',
    body: "We couldn't resolve a league for this domain. Please check the URL or contact support.",
  },
  /** Built-in nav links, also the section pages' tab titles. */
  nav: {
    home: 'Home',
    schedule: 'Schedule',
    players: 'Players',
    teams: 'Teams',
    stats: 'Stats',
    gallery: 'Gallery',
    blog: 'Blog',
    venues: 'Venues',
    live: 'Live',
    tickets: 'Tickets',
  },
  /** Tab titles of the member and registration pages (#1463). A registration or
   *  invitation uses its own heading once loaded; these are the fallbacks. */
  memberTitles: {
    signIn: 'Sign in',
    registrations: 'Register',
    registration: 'Register',
    account: 'My account',
    forgotPassword: 'Reset your password',
    resetPassword: 'Choose a new password',
    join: 'Invitation',
    membersOnly: 'Members only',
  },
  home: {
    /** Default section titles; a league can rename each one. */
    sections: {
      standings: 'Standings',
      upcoming: 'Upcoming Matches',
      recentResults: 'Recent Results',
      sponsors: 'Sponsors',
      announcements: 'Announcements',
      gallery: 'Gallery',
      highlight: 'Highlight',
      about: 'About',
      links: 'Links',
    },
    galleryImageAlt: 'Gallery image',
  },
  game: {
    /** The basketball box-score drill-down (other sports use their pack's names). */
    drillDown: {
      points: 'Points',
      rebounds: 'Rebounds',
      assists: 'Assists',
      steals: 'Steals',
      blocks: 'Blocks',
      threePointers: '3-Pointers',
      fieldGoals: 'Field Goals',
      freeThrows: 'Free Throws',
      turnovers: 'Turnovers',
      fouls: 'Fouls',
      minutes: 'Minutes',
    },
  },
  players: {
    filter: {
      active: 'Active Players',
      inactive: 'Inactive Players',
    },
  },
  share: {
    player: 'Share Player Stats',
    team: 'Share Team Stats',
  },
  sale: {
    buyer: {
      name: 'Name',
      namePlaceholder: 'Full name',
      email: 'Email',
      emailPlaceholder: 'you@example.com',
      phone: 'Phone',
      phonePlaceholder: '(555) 555-5555',
      phoneHelp: 'recommended, get your ticket QR by text',
    },
  },
  tickets: {
    venueFallback: 'Venue',
  },
  schedule: {
    allVenues: 'All venues',
  },
}

export default en
